<footer
  data-testid="htc-footer"
  class="footer"
  [ngClass]="{
    'footer-with-toolbar': footerService.footerData.showTools,
    'footer-without-toolbar': !footerService.footerData.showTools,
    'footer-without-button': !footerService.footerData.showButton
  }">
  <ng-template #footerContent>
    @if (footerService.footerData.showButton) {
      <htc-button-with-icon
        data-testid="htc-footer-next-button"
        [classes]="footerService.footerData.buttonIconClasses"
        [btnText]="footerService.footerData.buttonText | translate"
        [imagePath]="footerService.footerData.buttonIconPath"
        [enable]="buttonEnabled && !isActivityCompleteInProgress"
        (btnClicked)="
          footerService.onFooterButtonClicked(
            $event,
            pageTransitionsService.isAnimating()
          )
        "
        [clickType]="clickType"
        [clickDescriptor]="clickDescriptor">
      </htc-button-with-icon>
    }
  </ng-template>
  @if (
    buttonEnabled &&
    !isActivityCompleteInProgress &&
    activityService.isPreK2ReadingActivity()
  ) {
    <div class="prek2-footer-container">
      <div class="box-shadow btn btn-footer btn-with-right-icon"></div>
      <ng-container *ngTemplateOutlet="footerContent"></ng-container>
    </div>
  } @else {
    @if (footerService.footerData.showButton) {
      <htc-button-with-icon
        data-testid="htc-footer-next-button"
        [classes]="footerService.footerData.buttonIconClasses"
        [btnText]="footerService.footerData.buttonText | translate"
        [imagePath]="footerService.footerData.buttonIconPath"
        [enable]="buttonEnabled && !isActivityCompleteInProgress"
        (btnClicked)="
          footerService.onFooterButtonClicked(
            $event,
            pageTransitionsService.isAnimating()
          )
        "
        [clickType]="clickType"
        [clickDescriptor]="clickDescriptor">
      </htc-button-with-icon>
    }
  }
  @if (footerService.footerData.showTools) {
    <htc-toolbar data-testid="htc-footer-toolbar"></htc-toolbar>
  }
</footer>
